module.exports = __webpack_public_path__ + "img/supplierEntryGuidelines_banner.170d9306.png";